import { Component } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';

@Component({
  selector: 'lgb-set-up',
  imports: [
    UiModule
  ],
  templateUrl: './set-up.html',
  styleUrl: './set-up.css',
})
export class SetUp {
  scrollTo(id: string){
    const element=document.getElementById(id);

    if(element){
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
}
